import { useState } from 'react';
import { ServiceLogForm } from './ServiceLogForm';
import { useAuthStore } from '../../stores/authStore';

// =============================================================================
// TYPES
// =============================================================================

export interface ServiceLogButtonProps {
  clientId: string;
  clientName: string;
  /** Optional: Show as already logged (e.g., from today's logs check) */
  alreadyLogged?: boolean;
  /** Callback when service is logged */
  onLogComplete?: () => void;
}

// =============================================================================
// COMPONENT
// =============================================================================

export function ServiceLogButton({
  clientId,
  clientName,
  alreadyLogged = false,
  onLogComplete,
}: ServiceLogButtonProps) {
  const [showForm, setShowForm] = useState(false);
  const { user } = useAuthStore();

  const handleSuccess = () => {
    setShowForm(false);
    onLogComplete?.();
  };

  if (alreadyLogged) {
    return (
      <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
        <span className="text-xl" role="img" aria-label="Logged">
          ✓
        </span>
      </div>
    );
  }

  return (
    <>
      <button
        onClick={() => setShowForm(true)}
        className="w-10 h-10 rounded-full bg-primary-500 hover:bg-primary-600 active:bg-primary-700 flex items-center justify-center transition-colors touch-manipulation"
        aria-label={`Log service for ${clientName}`}
      >
        <span className="text-xl" role="img" aria-label="Log service">
          🌿
        </span>
      </button>

      {showForm && user && (
        <ServiceLogForm
          employeeId={user.email || ''}
          employeeName={user.name || ''}
          clientId={clientId}
          clientName={clientName}
          onSuccess={handleSuccess}
          onCancel={() => setShowForm(false)}
        />
      )}
    </>
  );
}
